module.exports = __webpack_public_path__ + "img/6.6444561a.jpg";